import React from 'react';
import { IoVideocamOutline, IoCallOutline } from 'react-icons/io5';

interface CallButtonsProps {
  onVideoCall: () => void;
  onAudioCall: () => void;
}

const CallButtons: React.FC<CallButtonsProps> = ({ onVideoCall, onAudioCall }) => {
  return (
    <div className="flex gap-2">
      <button
        onClick={onAudioCall}
        className="p-2 hover:bg-[#2A3942] rounded-full transition-colors text-gray-300"
        title="Audio Call"
      >
        <IoCallOutline size={22} />
      </button>
      <button
        onClick={onVideoCall}
        className="p-2 hover:bg-[#2A3942] rounded-full transition-colors text-gray-300"
        title="Video Call"
      >
        <IoVideocamOutline size={22} />
      </button>
    </div>
  );
};

export default CallButtons;
